import { accessControlApi } from './accessControlApi';

export type accessControlTagTypes = 'access-control' | 'site-settings';

export const enhancedAccessControlApi = accessControlApi.enhanceEndpoints<accessControlTagTypes>({
  addTagTypes: ['access-control'],
  endpoints: {
    getSiteCredentialsSettingsAc: {
      providesTags: [{ id: 'site-credential-setting', type: 'access-control' }],
    },
    getUserCredentialsValidityAc: {
      providesTags: [{ id: 'user-credentials-validity', type: 'access-control' }],
    },
    updateSiteBluetoothAc: {
      invalidatesTags: [{ id: 'site-credential-setting', type: 'access-control' }],
    },
    updateSiteCustomLocationAc: {
      invalidatesTags: [{ id: 'site-credential-setting', type: 'access-control' }],
    },
    updateSiteGuestPinSettingsAc: {
      invalidatesTags: [{ id: 'site', type: 'site-settings' }],
    },
  },
});
